module.exports = __webpack_public_path__ + "img/contacts--promo.1240e08.jpg";